import type { ReactNode } from 'react'
import type { TFunction } from 'i18next'
import IconCarbonMisuseOutline from '@/shared/icons/IconCarbonMisuseOutline'
import IconCheckCircle from '@/shared/icons/NewDesign/IconCheckCircle'
import IconClock from '@/shared/icons/NewDesign/IconClock'
import { productIcon } from './productDisplay'
import type { SaleProductStatus } from './saleProductStatus'
import useProductListItem from './useProductListItem'
import { ProductIcon, ProductItem, ProductName, VisuallyHidden } from './styled-components'

const STATUS_ICONS: Partial<Record<SaleProductStatus, ReactNode>> = {
  validated: <IconCheckCircle size={16} color='currentColor' />,
  failed: <IconCarbonMisuseOutline size={16} color='currentColor' />,
  waiting: <IconClock size={16} />,
}

interface ProductListItemProps {
  saleKey: string
  selected: boolean
  onSelect: (key: string) => void
  formulaSlotRef: (node: HTMLDivElement | null) => void
  t: TFunction
}

const ProductListItem = ({ saleKey, selected, onSelect, formulaSlotRef, t }: ProductListItemProps) => {
  const { status, label, statusLabel, select } = useProductListItem({ saleKey, onSelect, t })

  return (
    <li>
      <ProductItem
        type='button'
        id={`tab-${saleKey}`}
        $status={status}
        $selected={selected}
        aria-current={selected ? 'true' : undefined}
        onClick={select}
      >
        <ProductIcon $status='idle' $selected={selected}>
          {productIcon(saleKey, 18)}
        </ProductIcon>
        <ProductName>{label}</ProductName>
        {STATUS_ICONS[status] && (
          <ProductIcon $status={status} $selected={selected} aria-hidden='true'>
            {STATUS_ICONS[status]}
          </ProductIcon>
        )}
        {statusLabel !== null && <VisuallyHidden>, {statusLabel}</VisuallyHidden>}
      </ProductItem>
      {selected && <div ref={formulaSlotRef} />}
    </li>
  )
}

export default ProductListItem
